// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Payment-space1-QIrv9 {
	margin-bottom: 6px !important;
}

.Payment-space2-CUqg0 {
	margin-bottom: 12px !important;
}

.Payment-space3-cWOwu {
	margin-bottom: 18px !important;
}

.Payment-space4-v9Ls8 {
	margin-bottom: 24px !important;
}

.Payment-space5-tnfZx {
	margin-bottom: 30px !important;
}

.Payment-space6-belK6 {
	margin-bottom: 36px !important;
}

.Payment-space7-D9uiy {
	margin-bottom: 42px !important;
}

.Payment-spaceTop8-pQe8C {
	margin-bottom: 48px !important;
}

.Payment-spaceTop1-sS8lr {
	margin-top: 6px !important;
}

.Payment-spaceTop2-kxw01 {
	margin-top: 12px !important;
}

.Payment-spaceTop3-wm9V4 {
	margin-top: 18px !important;
}

.Payment-spaceTop4-xcmvK {
	margin-top: 24px !important;
}

.Payment-spaceTop5-KuFcq {
	margin-top: 30px !important;
}

.Payment-spaceTop6-zSLWx {
	margin-top: 36px !important;
}

.Payment-spaceTop7-e5N1l {
	margin-top: 42px !important;
}

.Payment-spaceTop8-pQe8C {
	margin-top: 48px !important;
}

.Payment-noMargin-WG4qv {
	margin: 0px !important;
}

.Payment-padding1-mbvmb {
	padding-bottom: 6px !important;
}

.Payment-padding2-M01UU {
	padding-bottom: 12px !important;
}

.Payment-padding3-M6ujA {
	padding-bottom: 18px !important;
}

.Payment-padding4-jVIjb {
	padding-bottom: 24px !important;
}

.Payment-padding5-GIzjv {
	padding-bottom: 30px !important;
}

.Payment-padding6-Th66m {
	padding-bottom: 36px !important;
}

.Payment-padding7-fMl66 {
	padding-bottom: 42px !important;
}

.Payment-paddingTop1-qkLse {
	padding-top: 6px !important;
}

.Payment-paddingTop2-oYgTf {
	padding-top: 12px !important;
}

.Payment-paddingTop3-M4Qs3 {
	padding-top: 18px !important;
}

.Payment-paddingTop4-fpXPa {
	padding-top: 24px !important;
}

.Payment-paddingTop5-Fq8GN {
	padding-top: 30px !important;
}

.Payment-paddingTop6-s6g6M {
	padding-top: 36px !important;
}

.Payment-paddingTop7-EBVk1 {
	padding-top: 42px !important;
}

.Payment-noPadding-aR08w {
	padding: 0px !important;
}

.Payment-textBold-G3B7f {
	font-weight: 500 !important;
}

.Payment-textBolder-NyfrI {
	font-weight: 700 !important;
}

.Payment-textNormal-wQGt5 {
	font-weight: normal !important;
}

.Payment-spaceBottom20-NpogV {
	margin-bottom: 20px;
}

.Payment-spaceBottom10-YEcby {
	margin-bottom: 10px;
}

.Payment-marginNone-KXRCM {
	margin: 0;
}

.Payment-spaceBottom15-F2TB8 {
	margin-bottom: 15px;
}

.Payment-marginTopNone-Br4FP {
	margin-top: 0;
}

.Payment-spaceTop11-YO2wB {
	margin-top: 11px;
}

.Payment-spaceTop21-RbNgn {
	margin-top: 21px;
}

.Payment-spaceTop20-G52G4 {
	margin-top: 20px;
}

.Payment-spaceTop10-cDrqL {
	margin-top: 10px;
}

/*New Design Text Colors */

.Payment-textDarkBlue-Nhx0_ {
	color: rgb(20, 39, 94) !important;
}

.Payment-textLightBlue-UHu2u {
	color: rgb(57, 87, 106) !important;
}

.Payment-textLightSandleGreen-tPTOF {
	color: rgb(76, 86, 41) !important;
}

.Payment-textLightBrown-hd0_J {
	color: rgb(115, 79, 33) !important;
}

.Payment-textMediumMaroon-ZvHwy {
	color: rgb(87, 37, 51) !important;
}

.Payment-textBrown-iIxz6 {
	color: rgb(160, 47, 24) !important;
}

.Payment-textMaroon-kzDRX {
	color: rgb(155, 49, 67) !important;
}

.Payment-textDarkBrown-EK2n2 {
	color: rgb(83, 18, 16) !important;
}

.Payment-textMediumBrown-fUPId {
	color: rgb(142, 28, 10) !important;
}

.Payment-textSkyBlue-Z5he2 {
	color: rgb(37, 117, 141) !important;
}

.Payment-textGray-keitb {
	color: rgb(77, 65, 51) !important;
}

.Payment-bookItPanel-UsuSg {
	font-size: 16px;
	padding: 5px;
}

.Payment-textLeft-ikKeg {
	text-align: left;
}

.Payment-textGray-keitb {
	color: var(--secondary-foreground);
	font-size: 14px;
}

.Payment-chevronIcon-HnRf4 {
	font-size: 1.5em;
	margin-top: 10px;
	font-weight: normal;
	font-style: normal;
}

.Payment-checkInDate-Q7OvT {
	font-size: 14px;
	color: var(--primary-foreground);
}

.Payment-pullLeft-rB5GJ {
	float: left;
}

.Payment-pullRight-or7S5 {
	float: right;
}

.Payment-h3-qQbrz {
	font-size: 20px;
	font-weight: normal;
}

.Payment-bookItDetails-kBBNH {
	font-size: 16px;
}

.Payment-textArea-Z7klR {
	height: 110px !important;
	border-radius: 0px;
	margin-top: 12px;
}

.Payment-textCenter-jPViS {
	text-align: center;
}

.Payment-paymentHeader-PS99Y {
	padding: 5px;
	font-size: 16px;
}

.Payment-textLight-_lTcy {
	color: var(--secondary-foreground);
}

.Payment-countryName-xcdP3 {
	margin: 0px 0px 8px;
}

.Payment-textRegular-VOXJN {
	font-weight: normal;
	color: var(--primary-foreground);
	margin: 0px;
	word-wrap: break-word;
	font-size: 19px;
	line-height: 24px;
	padding-top: 0px;
	padding-bottom: 0px;
}

.Payment-selectContainer-FQLul {
	font-size: 19px;
	line-height: 24px;
	color: var(--primary-foreground);
	position: relative;
	display: block;
}

.Payment-summaryCard-IJZrk {
	background: transparent;
	font-size: 16px;
}

.Payment-colCenter-Tv_JB {
	float: none;
	margin-left: auto;
	margin-right: auto;
}

.Payment-bannerImage-dOssq {
	height: 140px;
}

.Payment-hostProfilePhoto-FbLKH {
	margin-bottom: 0;
	margin-right: 30px;
	margin-top: -25px;
}

.Payment-profileAvatarSection-BAJ34 {
	position: relative;
	text-align: center;
	margin: 0 auto;
}

.Payment-profileAvatarLink-x7Cns {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	overflow: hidden;
	border-radius: 50%;
	background-color: var(--secondary-gray-bg);
	border: 2px solid var(--primary-border);
}

.Payment-profileAvatar-LishZ {
	height: 60px;
	width: 60px;
}

.Payment-panelHeader-DMJV1 {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
}

.Payment-textMuted-ZnuhA {
	color: var(--secondary-foreground);
	font-size: 16px;
}

.Payment-textLarge-vfM7u {
	font-size: 24px;
	line-height: 30px;
}

.Payment-listStyle-ktV7H {
	margin-bottom: 0;
	padding-left: 0;
	list-style: none;
}

.Payment-noBorder-BTOFm {
	border: 0px none !important;
}

.Payment-tableText-tz7gh {
	font-weight: normal;
	color: var(--primary-foreground);
}

.Payment-totalText-Ubj9k {
	border: 0;
	padding: 0;
	width: 100%;
	background: transparent;
	text-align: start;
	cursor: default;
	pointer-events: none;
	font-size: 24px;
	line-height: 30px;
}

a {
	color: var(--primary-link-foreground);
	text-decoration: none;
}

a:hover {
	color: var(--primary-link-foreground);
	cursor: pointer;
}

.Payment-horizondalLine-Uw3aN {
	margin-top: 15px;
	margin-bottom: 15px;
	border: 0;
	border-top: 1px solid var(--primary-border);
}

.Payment-formControlSelect-ONG_7 {
	padding: 8px 10px !important;
	width: 100%;
	display: inline-block;
	overflow: hidden;
	-webkit-appearance: none;
	   -moz-appearance: none;
	        appearance: none;
	max-width: 250px;
}

.Payment-colCenter-Tv_JB {
	border: 1px solid var(--primary-border);
	border-radius: 15px;
}

.Payment-backgroundCover-PszZo {
	background-size: cover;
	background-position: center center;
	background-repeat: no-repeat;
	background-color: var(--secondary-gray-bg);
	border-radius: 6px;
}

.Payment-profileAvatar-LishZ {
	height: 60px;
	width: 60px;
}

.Payment-panelHeader-DMJV1 {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	border-bottom-left-radius: 4px !important;
	border-bottom-right-radius: 4px !important;
}

.Payment-textMuted-ZnuhA {
	color: var(--secondary-foreground);
	font-size: 16px;
}

.Payment-textLarge-vfM7u {
	font-size: 24px;
	line-height: 30px;
}

.Payment-listStyle-ktV7H {
	margin: 3px 0;
	padding-left: 0;
	list-style: none;
}

.Payment-noBorder-BTOFm {
	border: 0px none !important;
}

.Payment-tableText-tz7gh {
	font-weight: normal;
}

.Payment-totalText-Ubj9k {
	border: 0;
	padding: 0;
	width: 100%;
	background: transparent;
	text-align: start;
	cursor: default;
	pointer-events: none;
	font-size: 24px;
	line-height: 30px;
}

a {
	color: var(--primary-link-foreground);
	text-decoration: none;
}

a:hover {
	color: var(--primary-link-foreground);
	cursor: pointer;
}

.Payment-horizondalLine-Uw3aN {
	margin: 15px 0;
	border-top: 1px solid var(--primary-border);
}

.Payment-displayInline-eMhY0 {
	display: inline-block;
}

.Payment-avatarWidth-M6Zks {
	width: 43%;
	text-align: center;
	padding-right: 15px;
}

.Payment-contentWidth-wujQW {
	width: 57%
}

.Payment-positionSticky-dBVhX {
	position: sticky !important;
	top: 20px;
}

.Payment-secondSection-VUDK4 {
	padding: 20px;
	border-bottom: 1px solid var(--primary-border);
	margin-bottom: 20px;
}

.Payment-propertyText-AY2gK {
	font-size: 18px;
	line-height: 24px;
}

.Payment-listItem-cJaYW {
	font-size: 14px;
	color: var(--secondary-foreground);
}

.Payment-postionRelative-hYP3o {
	position: relative;
}

.Payment-arrrowIcon-VtWrr {
	max-width: 24px;
}

.Payment-policyColor-RC1PG {
	color: var(--primary-link-foreground) !important;
	text-decoration: none !important;
}

.Payment-vtrMiddle-wiMLr {
	vertical-align: middle;
}

.Payment-textEllipsis-fI7ae {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.Payment-avatarImage-Dq4pM {
	width: 100%;
	max-width: 63px;
	border-radius: 50%;
	height: 63px;
}

.Payment-displayTable-W_3SD {
	display: table;
	width: 100%;
}

.Payment-displayTableRow-yhNxp {
	display: table-row;
	width: 100%;
}

.Payment-displayTableCell-AZDtQ {
	display: table-cell;
}

.Payment-avatarSection-xvoVi {
	width: 12%;
	padding-right: 12px;
}

.Payment-messageSection-htHVl {
	font-size: 18px;
}

.Payment-vtrTop-GLyAB {
	vertical-align: top;
}

.Payment-itemWidth-Wr8xy {
	padding-left: 9px;
}

.Payment-aboutNoMargin-nxtDN {
	margin-top: 0;
	padding-top: 0
}

.Payment-aboutPaymentDesc-mSQZD {
	margin: 15px 0 25px;
	font-size: 16px;
}

.Payment-paymentPadding-dWkEk {
	padding-left: 8px;
}

.Payment-cancelBtn-BwhYf {
	display: inline-block;
	margin-left: 25px;
}

.Payment-cancelLinkText-n1La1 {
	margin-left: 12px;
	padding: 8px 27px;
	color: var(--primary-link-foreground);
	font-size: 14px;
	cursor: pointer;
}

.Payment-cancelLinkText-n1La1:hover,
.Payment-cancelLinkText-n1La1:focus,
.Payment-cancelLinkText-n1La1:active,
.Payment-cancelLinkText-n1La1:active:hover,
.Payment-cancelLinkText-n1La1:active:focus {
	color: var(--primary-link-foreground);
}

.Payment-specialPriceText-VMx6e {
	display: inline-block;
	vertical-align: middle;
}

.Payment-faqImage-BpKgJ {
	width: 100%;
	max-width: 19px;
	vertical-align: middle;
	margin-right: 5px;
}

.Payment-fullWidth-PGzYe {
	width: 100%;
}

.Payment-pullRight-or7S5 {
	float: right !important;
}

.Payment-noBoxShadow-FU2d3 {
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
	outline: none !important;
}

.Payment-labelText-WEZQf {
	margin-bottom: 0 !important;
	font-size: 14px !important;
	font-weight: 600;
}

.Payment-stripeImg-U2IIn {
	max-width: 170px;
}

.Payment-cardSection-nrmkY {
	padding: 25px !important;
	margin: 20px 15px 0;
	border-radius: 6px;
	border: 1px solid var(--primary-border);
}

.Payment-titleText-MSD6y {
	font-size: 26px;
	font-weight: 600;
	margin-bottom: 30px;
}

.Payment-dateTitle-rZvi2 {
	font-size: 18px;
	margin-bottom: 7px;
}

.Payment-showDate-_Pqlu {
	color: var(--secondary-foreground);
}

.Payment-flex-Fa0Rq {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.Payment-disabledLink-wZA9y {
	pointer-events: none;
	cursor: default;
	opacity: 0.6;
}

.Payment-editCss-gIc77 {
	color: var(--primary-link-foreground) !important;
	font-size: 16px;
	text-decoration: underline;
}

.Payment-editIcon-K_Rqt {
	position: relative;
	top: -2px;
	display: inline-block;
	margin-left: 3px;
}

.Payment-marginTop-x1ToH {
	margin-top: 25px;
}

.Payment-commonBorder-dzD8g {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.Payment-grid-NQ40j {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	color: var(--secondary-foreground);
	padding: 0 20px 10px 20px;
	font-size: 16px;
	gap: 10px;
}

.Payment-totalValue-xSkBU {
	border-top: 1px solid var(--primary-border);
	padding: 20px;
	color: var(--primary-foreground);
	font-size: 18px;
	margin-top: 10px;
	font-weight: 600;
}

.Payment-policyCss-AUmVn {
	text-align: center;
	margin: 30px 0;
}

.Payment-noPaddingLeft-wOWnA {
	padding-left: 0;
}

.Payment-noPaddingRight-Bje1n {
	padding-right: 0;
}

.Payment-noPadding-aR08w {
	padding: 0;
}

.Payment-payPalTop-gARmw {
	margin-top: 20px;
}

.Payment-footerBtns-RyNH0 {
	border-top: 1px solid var(--primary-border);
	margin: 25px 0 40px;
	text-align: right;
	padding-top: 25px;
}

.Payment-pricingTitle-fiE0U {
	font-size: 18px;
	margin-bottom: 15px;
	padding-left: 20px;
}

.Payment-reviewFlex-bb1nh {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.Payment-dotsCss-dMREO {
	margin: 0 8px;
}

.Payment-starCss-G9j7P {
	position: relative;
	top: 4px;
	margin-right: 2px;
}

.Payment-radioTextSection-x2zLF {
	font-weight: 400;
}

.Payment-hostFlex-wPeJt {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-column-gap: 15px;
	   -moz-column-gap: 15px;
	        column-gap: 15px;
}

.Payment-dFlex-ueCcd {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.Payment-paymentText-AJbLr {
	margin-top: 0;
	font-size: 20px;
}

.Payment-errorMessage-VcIzk {
	margin-bottom: 5px;
	display: block;
	color: var(--alert-color);
	font-size: 14px;
	font-weight: normal;
}

.Payment-loaderFlex-wJfvb {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-column-gap: 3px;
	   -moz-column-gap: 3px;
	        column-gap: 3px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

@media screen and (max-width: 1200px) {
	.Payment-colCenter-Tv_JB {
		margin: 0 15px;
	}
}

@media (max-width: 1200px) and (min-width: 992px) {
	.Payment-positionSticky-dBVhX {
		top: 100px;
	}
}

@media (max-width: 1199px) and (min-width: 992px) {
	.Payment-avatarWidth-M6Zks {
		width: 40%;
	}

	.Payment-contentWidth-wujQW {
		width: 60%;
	}

	.Payment-propertyText-AY2gK {
		line-height: 24px;
	}
}

@media screen and (max-width: 1199px) {
	.Payment-listItem-cJaYW {
		font-size: 14px;
	}

	.Payment-bookItPanel-UsuSg {
		padding: 60px 15px 0;
	}
}

@media (max-width: 991px) and (min-width: 640px) {
	.Payment-avatarWidth-M6Zks {
		width: 40%;
		text-align: center;
		padding-right: 6px;
	}

	.Payment-contentWidth-wujQW {
		width: 60%;
	}

	.Payment-propertyText-AY2gK {
		line-height: 24px;
	}

}

@media screen and (max-width: 767px) {
	.Payment-flexwrap-aniIg {
		-ms-flex-wrap: wrap;
		    flex-wrap: wrap;
	}

	.Payment-paddingRight15-vynDN {
		padding-right: 15px !important;
	}

	.Payment-paddingLeft15-cKwx8 {
		padding-left: 15px !important;
	}

	.Payment-expireSection-LsuJO {
		margin-bottom: 12px;
		padding-top: 0px !important;
	}

	.Payment-cardSection-nrmkY {
		margin: 20px 0px 0px;
	}

	.Payment-responsivecardSection-T9w6t {
		padding: 0 15px !important;
	}

	.Payment-noMobileLeftPadding-qcYkJ {
		padding-left: 0;
	}

	.Payment-noMobileRightPadding-N9pdz {
		padding-right: 0;
	}
}

@media screen and (max-width: 640px) {
	.Payment-smPadding-eHMr7 {
		padding: 0;
	}
}

@media screen and (max-width: 767px) {
	.Payment-avatarWidth-M6Zks {
		width: 40%;
	}

	.Payment-contentWidth-wujQW {
		width: 60%;
	}

	.Payment-propertyText-AY2gK {
		font-size: 16px;
		line-height: 18px;
	}

	.Payment-bannerImage-dOssq {
		padding-top: 70%;
	}

	.Payment-profileAvatar-LishZ {
		width: 50px;
		height: 50px;
	}

	.Payment-avatarSection-xvoVi {
		width: 24%;
		padding-right: 6px;
	}

	.Payment-vtrTopSm-BJylt {
		vertical-align: top;
	}
}

@media screen and (max-width:991px) {
	.Payment-positionSticky-dBVhX {
		position: inherit !important;
		top: auto;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Payment/Payment.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,eAAe;CACf,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kCAAkC;CAClC,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,wBAAwB;CACxB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,gCAAgC;CAChC,WAAW;CACX,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gCAAgC;CAChC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,uBAAuB;CACvB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB,0CAA0C;CAC1C,uCAAuC;AACxC;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;AAC/C;;AAEA;CACC,kCAAkC;CAClC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,mBAAmB;CACnB,gCAAgC;AACjC;;AAEA;CACC,SAAS;CACT,UAAU;CACV,WAAW;CACX,uBAAuB;CACvB,iBAAiB;CACjB,eAAe;CACf,oBAAoB;CACpB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,qCAAqC;CACrC,qBAAqB;AACtB;;AAEA;CACC,qCAAqC;CACrC,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,SAAS;CACT,2CAA2C;AAC5C;;AAIA;CACC,4BAA4B;CAC5B,WAAW;CACX,qBAAqB;CACrB,gBAAgB;CAChB,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,uCAAuC;CACvC,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;CACtB,kCAAkC;CAClC,4BAA4B;CAC5B,0CAA0C;CAC1C,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,yCAAyC;CACzC,0CAA0C;AAC3C;;AAEA;CACC,kCAAkC;CAClC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,UAAU;CACV,WAAW;CACX,uBAAuB;CACvB,iBAAiB;CACjB,eAAe;CACf,oBAAoB;CACpB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,qCAAqC;CACrC,qBAAqB;AACtB;;AAEA;CACC,qCAAqC;CACrC,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,2CAA2C;AAC5C;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC;AACD;;AAEA;CACC,2BAA2B;CAC3B,SAAS;AACV;;AAEA;CACC,aAAa;CACb,8CAA8C;CAC9C,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gDAAgD;CAChD,gCAAgC;AACjC;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb;AACD;;AAEA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,qCAAqC;CACrC,eAAe;CACf,eAAe;AAChB;;AAEA;;;;;CAKC,qCAAqC;AACtC;;AAEA;CACC,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,uBAAuB;AACxB;;AAGA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,wBAAwB;AACzB;;AAEA;CACC,2BAA2B;CAC3B,0BAA0B;CAC1B,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,wBAAwB;CACxB,mBAAmB;CACnB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;CACpB,eAAe;CACf,YAAY;AACb;;AAEA;CACC,gDAAgD;CAChD,eAAe;CACf,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,kCAAkC;CAClC,yBAAyB;CACzB,eAAe;CACf,SAAS;AACV;;AAEA;CACC,2CAA2C;CAC3C,aAAa;CACb,gCAAgC;CAChC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;CACnB,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;AACjB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;;AAEA;CACC,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,yBAAyB;CACzB,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,uBAAe;IAAf,oBAAe;SAAf,eAAe;CACf,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,UAAU;CACX;AACD;;AAEA;CACC;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,eAAe;CAChB;;CAEA;EACC,oBAAoB;CACrB;AACD;;AAEA;CACC;EACC,UAAU;EACV,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,iBAAiB;CAClB;;AAED;;AAEA;CACC;EACC,mBAAe;MAAf,eAAe;CAChB;;CAEA;EACC,8BAA8B;CAC/B;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC,mBAAmB;EACnB,2BAA2B;CAC5B;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,UAAU;CACX;AACD;;AAEA;CACC;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,UAAU;EACV,kBAAkB;CACnB;;CAEA;EACC,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,4BAA4B;EAC5B,SAAS;CACV;AACD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n.bookItPanel {\n\tfont-size: 16px;\n\tpadding: 5px;\n}\n\n.textLeft {\n\ttext-align: left;\n}\n\n.textGray {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 14px;\n}\n\n.chevronIcon {\n\tfont-size: 1.5em;\n\tmargin-top: 10px;\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n\n.checkInDate {\n\tfont-size: 14px;\n\tcolor: var(--primary-foreground);\n}\n\n.pullLeft {\n\tfloat: left;\n}\n\n.pullRight {\n\tfloat: right;\n}\n\n.h3 {\n\tfont-size: 20px;\n\tfont-weight: normal;\n}\n\n.bookItDetails {\n\tfont-size: 16px;\n}\n\n.textArea {\n\theight: 110px !important;\n\tborder-radius: 0px;\n\tmargin-top: 12px;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.paymentHeader {\n\tpadding: 5px;\n\tfont-size: 16px;\n}\n\n.textLight {\n\tcolor: var(--secondary-foreground);\n}\n\n.countryName {\n\tmargin: 0px 0px 8px;\n}\n\n.textRegular {\n\tfont-weight: normal;\n\tcolor: var(--primary-foreground);\n\tmargin: 0px;\n\tword-wrap: break-word;\n\tfont-size: 19px;\n\tline-height: 24px;\n\tpadding-top: 0px;\n\tpadding-bottom: 0px;\n}\n\n.selectContainer {\n\tfont-size: 19px;\n\tline-height: 24px;\n\tcolor: var(--primary-foreground);\n\tposition: relative;\n\tdisplay: block;\n}\n\n.summaryCard {\n\tbackground: transparent;\n\tfont-size: 16px;\n}\n\n.colCenter {\n\tfloat: none;\n\tmargin-left: auto;\n\tmargin-right: auto;\n}\n\n.bannerImage {\n\theight: 140px;\n}\n\n.hostProfilePhoto {\n\tmargin-bottom: 0;\n\tmargin-right: 30px;\n\tmargin-top: -25px;\n}\n\n.profileAvatarSection {\n\tposition: relative;\n\ttext-align: center;\n\tmargin: 0 auto;\n}\n\n.profileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\toverflow: hidden;\n\tborder-radius: 50%;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 2px solid var(--primary-border);\n}\n\n.profileAvatar {\n\theight: 60px;\n\twidth: 60px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.textMuted {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 16px;\n}\n\n.textLarge {\n\tfont-size: 24px;\n\tline-height: 30px;\n}\n\n.listStyle {\n\tmargin-bottom: 0;\n\tpadding-left: 0;\n\tlist-style: none;\n}\n\n.noBorder {\n\tborder: 0px none !important;\n}\n\n.tableText {\n\tfont-weight: normal;\n\tcolor: var(--primary-foreground);\n}\n\n.totalText {\n\tborder: 0;\n\tpadding: 0;\n\twidth: 100%;\n\tbackground: transparent;\n\ttext-align: start;\n\tcursor: default;\n\tpointer-events: none;\n\tfont-size: 24px;\n\tline-height: 30px;\n}\n\na {\n\tcolor: var(--primary-link-foreground);\n\ttext-decoration: none;\n}\n\na:hover {\n\tcolor: var(--primary-link-foreground);\n\tcursor: pointer;\n}\n\n.horizondalLine {\n\tmargin-top: 15px;\n\tmargin-bottom: 15px;\n\tborder: 0;\n\tborder-top: 1px solid var(--primary-border);\n}\n\n\n\n.formControlSelect {\n\tpadding: 8px 10px !important;\n\twidth: 100%;\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tappearance: none;\n\tmax-width: 250px;\n}\n\n.colCenter {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 15px;\n}\n\n.backgroundCover {\n\tbackground-size: cover;\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder-radius: 6px;\n}\n\n.profileAvatar {\n\theight: 60px;\n\twidth: 60px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tborder-bottom-left-radius: 4px !important;\n\tborder-bottom-right-radius: 4px !important;\n}\n\n.textMuted {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 16px;\n}\n\n.textLarge {\n\tfont-size: 24px;\n\tline-height: 30px;\n}\n\n.listStyle {\n\tmargin: 3px 0;\n\tpadding-left: 0;\n\tlist-style: none;\n}\n\n.noBorder {\n\tborder: 0px none !important;\n}\n\n.tableText {\n\tfont-weight: normal;\n}\n\n.totalText {\n\tborder: 0;\n\tpadding: 0;\n\twidth: 100%;\n\tbackground: transparent;\n\ttext-align: start;\n\tcursor: default;\n\tpointer-events: none;\n\tfont-size: 24px;\n\tline-height: 30px;\n}\n\na {\n\tcolor: var(--primary-link-foreground);\n\ttext-decoration: none;\n}\n\na:hover {\n\tcolor: var(--primary-link-foreground);\n\tcursor: pointer;\n}\n\n.horizondalLine {\n\tmargin: 15px 0;\n\tborder-top: 1px solid var(--primary-border);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n.avatarWidth {\n\twidth: 43%;\n\ttext-align: center;\n\tpadding-right: 15px;\n}\n\n.contentWidth {\n\twidth: 57%\n}\n\n.positionSticky {\n\tposition: sticky !important;\n\ttop: 20px;\n}\n\n.secondSection {\n\tpadding: 20px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tmargin-bottom: 20px;\n}\n\n.propertyText {\n\tfont-size: 18px;\n\tline-height: 24px;\n}\n\n.listItem {\n\tfont-size: 14px;\n\tcolor: var(--secondary-foreground);\n}\n\n.postionRelative {\n\tposition: relative;\n}\n\n.arrrowIcon {\n\tmax-width: 24px;\n}\n\n.policyColor {\n\tcolor: var(--primary-link-foreground) !important;\n\ttext-decoration: none !important;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.textEllipsis {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.avatarImage {\n\twidth: 100%;\n\tmax-width: 63px;\n\tborder-radius: 50%;\n\theight: 63px;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\twidth: 100%;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n}\n\n.avatarSection {\n\twidth: 12%;\n\tpadding-right: 12px;\n}\n\n.messageSection {\n\tfont-size: 18px;\n}\n\n.vtrTop {\n\tvertical-align: top;\n}\n\n.itemWidth {\n\tpadding-left: 9px;\n}\n\n.aboutNoMargin {\n\tmargin-top: 0;\n\tpadding-top: 0\n}\n\n.aboutPaymentDesc {\n\tmargin: 15px 0 25px;\n\tfont-size: 16px;\n}\n\n.paymentPadding {\n\tpadding-left: 8px;\n}\n\n.cancelBtn {\n\tdisplay: inline-block;\n\tmargin-left: 25px;\n}\n\n.cancelLinkText {\n\tmargin-left: 12px;\n\tpadding: 8px 27px;\n\tcolor: var(--primary-link-foreground);\n\tfont-size: 14px;\n\tcursor: pointer;\n}\n\n.cancelLinkText:hover,\n.cancelLinkText:focus,\n.cancelLinkText:active,\n.cancelLinkText:active:hover,\n.cancelLinkText:active:focus {\n\tcolor: var(--primary-link-foreground);\n}\n\n.specialPriceText {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n\n.faqImage {\n\twidth: 100%;\n\tmax-width: 19px;\n\tvertical-align: middle;\n\tmargin-right: 5px;\n}\n\n.fullWidth {\n\twidth: 100%;\n}\n\n.pullRight {\n\tfloat: right !important;\n}\n\n\n.noBoxShadow {\n\tbox-shadow: none !important;\n\toutline: none !important;\n}\n\n.labelText {\n\tmargin-bottom: 0 !important;\n\tfont-size: 14px !important;\n\tfont-weight: 600;\n}\n\n.stripeImg {\n\tmax-width: 170px;\n}\n\n.cardSection {\n\tpadding: 25px !important;\n\tmargin: 20px 15px 0;\n\tborder-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.titleText {\n\tfont-size: 26px;\n\tfont-weight: 600;\n\tmargin-bottom: 30px;\n}\n\n.dateTitle {\n\tfont-size: 18px;\n\tmargin-bottom: 7px;\n}\n\n.showDate {\n\tcolor: var(--secondary-foreground);\n}\n\n.flex {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.disabledLink {\n\tpointer-events: none;\n\tcursor: default;\n\topacity: 0.6;\n}\n\n.editCss {\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-size: 16px;\n\ttext-decoration: underline;\n}\n\n.editIcon {\n\tposition: relative;\n\ttop: -2px;\n\tdisplay: inline-block;\n\tmargin-left: 3px;\n}\n\n.marginTop {\n\tmargin-top: 25px;\n}\n\n.commonBorder {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.grid {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tcolor: var(--secondary-foreground);\n\tpadding: 0 20px 10px 20px;\n\tfont-size: 16px;\n\tgap: 10px;\n}\n\n.totalValue {\n\tborder-top: 1px solid var(--primary-border);\n\tpadding: 20px;\n\tcolor: var(--primary-foreground);\n\tfont-size: 18px;\n\tmargin-top: 10px;\n\tfont-weight: 600;\n}\n\n.policyCss {\n\ttext-align: center;\n\tmargin: 30px 0;\n}\n\n.noPaddingLeft {\n\tpadding-left: 0;\n}\n\n.noPaddingRight {\n\tpadding-right: 0;\n}\n\n.noPadding {\n\tpadding: 0;\n}\n\n.payPalTop {\n\tmargin-top: 20px;\n}\n\n.footerBtns {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 25px 0 40px;\n\ttext-align: right;\n\tpadding-top: 25px;\n}\n\n.pricingTitle {\n\tfont-size: 18px;\n\tmargin-bottom: 15px;\n\tpadding-left: 20px;\n}\n\n.reviewFlex {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.dotsCss {\n\tmargin: 0 8px;\n}\n\n.starCss {\n\tposition: relative;\n\ttop: 4px;\n\tmargin-right: 2px;\n}\n\n.radioTextSection {\n\tfont-weight: 400;\n}\n\n.hostFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tcolumn-gap: 15px;\n}\n\n.dFlex {\n\tdisplay: flex;\n}\n\n.paymentText {\n\tmargin-top: 0;\n\tfont-size: 20px;\n}\n\n.errorMessage {\n\tmargin-bottom: 5px;\n\tdisplay: block;\n\tcolor: var(--alert-color);\n\tfont-size: 14px;\n\tfont-weight: normal;\n}\n\n.loaderFlex {\n\tdisplay: flex;\n\tcolumn-gap: 3px;\n\talign-items: center;\n}\n\n@media screen and (max-width: 1200px) {\n\t.colCenter {\n\t\tmargin: 0 15px;\n\t}\n}\n\n@media (max-width: 1200px) and (min-width: 992px) {\n\t.positionSticky {\n\t\ttop: 100px;\n\t}\n}\n\n@media (max-width: 1199px) and (min-width: 992px) {\n\t.avatarWidth {\n\t\twidth: 40%;\n\t}\n\n\t.contentWidth {\n\t\twidth: 60%;\n\t}\n\n\t.propertyText {\n\t\tline-height: 24px;\n\t}\n}\n\n@media screen and (max-width: 1199px) {\n\t.listItem {\n\t\tfont-size: 14px;\n\t}\n\n\t.bookItPanel {\n\t\tpadding: 60px 15px 0;\n\t}\n}\n\n@media (max-width: 991px) and (min-width: 640px) {\n\t.avatarWidth {\n\t\twidth: 40%;\n\t\ttext-align: center;\n\t\tpadding-right: 6px;\n\t}\n\n\t.contentWidth {\n\t\twidth: 60%;\n\t}\n\n\t.propertyText {\n\t\tline-height: 24px;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.flexwrap {\n\t\tflex-wrap: wrap;\n\t}\n\n\t.paddingRight15 {\n\t\tpadding-right: 15px !important;\n\t}\n\n\t.paddingLeft15 {\n\t\tpadding-left: 15px !important;\n\t}\n\n\t.expireSection {\n\t\tmargin-bottom: 12px;\n\t\tpadding-top: 0px !important;\n\t}\n\n\t.cardSection {\n\t\tmargin: 20px 0px 0px;\n\t}\n\n\t.responsivecardSection {\n\t\tpadding: 0 15px !important;\n\t}\n\n\t.noMobileLeftPadding {\n\t\tpadding-left: 0;\n\t}\n\n\t.noMobileRightPadding {\n\t\tpadding-right: 0;\n\t}\n}\n\n@media screen and (max-width: 640px) {\n\t.smPadding {\n\t\tpadding: 0;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.avatarWidth {\n\t\twidth: 40%;\n\t}\n\n\t.contentWidth {\n\t\twidth: 60%;\n\t}\n\n\t.propertyText {\n\t\tfont-size: 16px;\n\t\tline-height: 18px;\n\t}\n\n\t.bannerImage {\n\t\tpadding-top: 70%;\n\t}\n\n\t.profileAvatar {\n\t\twidth: 50px;\n\t\theight: 50px;\n\t}\n\n\t.avatarSection {\n\t\twidth: 24%;\n\t\tpadding-right: 6px;\n\t}\n\n\t.vtrTopSm {\n\t\tvertical-align: top;\n\t}\n}\n\n@media screen and (max-width:991px) {\n\t.positionSticky {\n\t\tposition: inherit !important;\n\t\ttop: auto;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Payment-space1-QIrv9`,
	"space2": `Payment-space2-CUqg0`,
	"space3": `Payment-space3-cWOwu`,
	"space4": `Payment-space4-v9Ls8`,
	"space5": `Payment-space5-tnfZx`,
	"space6": `Payment-space6-belK6`,
	"space7": `Payment-space7-D9uiy`,
	"spaceTop8": `Payment-spaceTop8-pQe8C`,
	"spaceTop1": `Payment-spaceTop1-sS8lr`,
	"spaceTop2": `Payment-spaceTop2-kxw01`,
	"spaceTop3": `Payment-spaceTop3-wm9V4`,
	"spaceTop4": `Payment-spaceTop4-xcmvK`,
	"spaceTop5": `Payment-spaceTop5-KuFcq`,
	"spaceTop6": `Payment-spaceTop6-zSLWx`,
	"spaceTop7": `Payment-spaceTop7-e5N1l`,
	"noMargin": `Payment-noMargin-WG4qv`,
	"padding1": `Payment-padding1-mbvmb`,
	"padding2": `Payment-padding2-M01UU`,
	"padding3": `Payment-padding3-M6ujA`,
	"padding4": `Payment-padding4-jVIjb`,
	"padding5": `Payment-padding5-GIzjv`,
	"padding6": `Payment-padding6-Th66m`,
	"padding7": `Payment-padding7-fMl66`,
	"paddingTop1": `Payment-paddingTop1-qkLse`,
	"paddingTop2": `Payment-paddingTop2-oYgTf`,
	"paddingTop3": `Payment-paddingTop3-M4Qs3`,
	"paddingTop4": `Payment-paddingTop4-fpXPa`,
	"paddingTop5": `Payment-paddingTop5-Fq8GN`,
	"paddingTop6": `Payment-paddingTop6-s6g6M`,
	"paddingTop7": `Payment-paddingTop7-EBVk1`,
	"noPadding": `Payment-noPadding-aR08w`,
	"textBold": `Payment-textBold-G3B7f`,
	"textBolder": `Payment-textBolder-NyfrI`,
	"textNormal": `Payment-textNormal-wQGt5`,
	"spaceBottom20": `Payment-spaceBottom20-NpogV`,
	"spaceBottom10": `Payment-spaceBottom10-YEcby`,
	"marginNone": `Payment-marginNone-KXRCM`,
	"spaceBottom15": `Payment-spaceBottom15-F2TB8`,
	"marginTopNone": `Payment-marginTopNone-Br4FP`,
	"spaceTop11": `Payment-spaceTop11-YO2wB`,
	"spaceTop21": `Payment-spaceTop21-RbNgn`,
	"spaceTop20": `Payment-spaceTop20-G52G4`,
	"spaceTop10": `Payment-spaceTop10-cDrqL`,
	"textDarkBlue": `Payment-textDarkBlue-Nhx0_`,
	"textLightBlue": `Payment-textLightBlue-UHu2u`,
	"textLightSandleGreen": `Payment-textLightSandleGreen-tPTOF`,
	"textLightBrown": `Payment-textLightBrown-hd0_J`,
	"textMediumMaroon": `Payment-textMediumMaroon-ZvHwy`,
	"textBrown": `Payment-textBrown-iIxz6`,
	"textMaroon": `Payment-textMaroon-kzDRX`,
	"textDarkBrown": `Payment-textDarkBrown-EK2n2`,
	"textMediumBrown": `Payment-textMediumBrown-fUPId`,
	"textSkyBlue": `Payment-textSkyBlue-Z5he2`,
	"textGray": `Payment-textGray-keitb`,
	"bookItPanel": `Payment-bookItPanel-UsuSg`,
	"textLeft": `Payment-textLeft-ikKeg`,
	"chevronIcon": `Payment-chevronIcon-HnRf4`,
	"checkInDate": `Payment-checkInDate-Q7OvT`,
	"pullLeft": `Payment-pullLeft-rB5GJ`,
	"pullRight": `Payment-pullRight-or7S5`,
	"h3": `Payment-h3-qQbrz`,
	"bookItDetails": `Payment-bookItDetails-kBBNH`,
	"textArea": `Payment-textArea-Z7klR`,
	"textCenter": `Payment-textCenter-jPViS`,
	"paymentHeader": `Payment-paymentHeader-PS99Y`,
	"textLight": `Payment-textLight-_lTcy`,
	"countryName": `Payment-countryName-xcdP3`,
	"textRegular": `Payment-textRegular-VOXJN`,
	"selectContainer": `Payment-selectContainer-FQLul`,
	"summaryCard": `Payment-summaryCard-IJZrk`,
	"colCenter": `Payment-colCenter-Tv_JB`,
	"bannerImage": `Payment-bannerImage-dOssq`,
	"hostProfilePhoto": `Payment-hostProfilePhoto-FbLKH`,
	"profileAvatarSection": `Payment-profileAvatarSection-BAJ34`,
	"profileAvatarLink": `Payment-profileAvatarLink-x7Cns`,
	"profileAvatar": `Payment-profileAvatar-LishZ`,
	"panelHeader": `Payment-panelHeader-DMJV1`,
	"textMuted": `Payment-textMuted-ZnuhA`,
	"textLarge": `Payment-textLarge-vfM7u`,
	"listStyle": `Payment-listStyle-ktV7H`,
	"noBorder": `Payment-noBorder-BTOFm`,
	"tableText": `Payment-tableText-tz7gh`,
	"totalText": `Payment-totalText-Ubj9k`,
	"horizondalLine": `Payment-horizondalLine-Uw3aN`,
	"formControlSelect": `Payment-formControlSelect-ONG_7`,
	"backgroundCover": `Payment-backgroundCover-PszZo`,
	"displayInline": `Payment-displayInline-eMhY0`,
	"avatarWidth": `Payment-avatarWidth-M6Zks`,
	"contentWidth": `Payment-contentWidth-wujQW`,
	"positionSticky": `Payment-positionSticky-dBVhX`,
	"secondSection": `Payment-secondSection-VUDK4`,
	"propertyText": `Payment-propertyText-AY2gK`,
	"listItem": `Payment-listItem-cJaYW`,
	"postionRelative": `Payment-postionRelative-hYP3o`,
	"arrrowIcon": `Payment-arrrowIcon-VtWrr`,
	"policyColor": `Payment-policyColor-RC1PG`,
	"vtrMiddle": `Payment-vtrMiddle-wiMLr`,
	"textEllipsis": `Payment-textEllipsis-fI7ae`,
	"avatarImage": `Payment-avatarImage-Dq4pM`,
	"displayTable": `Payment-displayTable-W_3SD`,
	"displayTableRow": `Payment-displayTableRow-yhNxp`,
	"displayTableCell": `Payment-displayTableCell-AZDtQ`,
	"avatarSection": `Payment-avatarSection-xvoVi`,
	"messageSection": `Payment-messageSection-htHVl`,
	"vtrTop": `Payment-vtrTop-GLyAB`,
	"itemWidth": `Payment-itemWidth-Wr8xy`,
	"aboutNoMargin": `Payment-aboutNoMargin-nxtDN`,
	"aboutPaymentDesc": `Payment-aboutPaymentDesc-mSQZD`,
	"paymentPadding": `Payment-paymentPadding-dWkEk`,
	"cancelBtn": `Payment-cancelBtn-BwhYf`,
	"cancelLinkText": `Payment-cancelLinkText-n1La1`,
	"specialPriceText": `Payment-specialPriceText-VMx6e`,
	"faqImage": `Payment-faqImage-BpKgJ`,
	"fullWidth": `Payment-fullWidth-PGzYe`,
	"noBoxShadow": `Payment-noBoxShadow-FU2d3`,
	"labelText": `Payment-labelText-WEZQf`,
	"stripeImg": `Payment-stripeImg-U2IIn`,
	"cardSection": `Payment-cardSection-nrmkY`,
	"titleText": `Payment-titleText-MSD6y`,
	"dateTitle": `Payment-dateTitle-rZvi2`,
	"showDate": `Payment-showDate-_Pqlu`,
	"flex": `Payment-flex-Fa0Rq`,
	"disabledLink": `Payment-disabledLink-wZA9y`,
	"editCss": `Payment-editCss-gIc77`,
	"editIcon": `Payment-editIcon-K_Rqt`,
	"marginTop": `Payment-marginTop-x1ToH`,
	"commonBorder": `Payment-commonBorder-dzD8g`,
	"grid": `Payment-grid-NQ40j`,
	"totalValue": `Payment-totalValue-xSkBU`,
	"policyCss": `Payment-policyCss-AUmVn`,
	"noPaddingLeft": `Payment-noPaddingLeft-wOWnA`,
	"noPaddingRight": `Payment-noPaddingRight-Bje1n`,
	"payPalTop": `Payment-payPalTop-gARmw`,
	"footerBtns": `Payment-footerBtns-RyNH0`,
	"pricingTitle": `Payment-pricingTitle-fiE0U`,
	"reviewFlex": `Payment-reviewFlex-bb1nh`,
	"dotsCss": `Payment-dotsCss-dMREO`,
	"starCss": `Payment-starCss-G9j7P`,
	"radioTextSection": `Payment-radioTextSection-x2zLF`,
	"hostFlex": `Payment-hostFlex-wPeJt`,
	"dFlex": `Payment-dFlex-ueCcd`,
	"paymentText": `Payment-paymentText-AJbLr`,
	"errorMessage": `Payment-errorMessage-VcIzk`,
	"loaderFlex": `Payment-loaderFlex-wJfvb`,
	"flexwrap": `Payment-flexwrap-aniIg`,
	"paddingRight15": `Payment-paddingRight15-vynDN`,
	"paddingLeft15": `Payment-paddingLeft15-cKwx8`,
	"expireSection": `Payment-expireSection-LsuJO`,
	"responsivecardSection": `Payment-responsivecardSection-T9w6t`,
	"noMobileLeftPadding": `Payment-noMobileLeftPadding-qcYkJ`,
	"noMobileRightPadding": `Payment-noMobileRightPadding-N9pdz`,
	"smPadding": `Payment-smPadding-eHMr7`,
	"vtrTopSm": `Payment-vtrTopSm-BJylt`
};
module.exports = ___CSS_LOADER_EXPORT___;
